/* eslint-disable no-useless-catch */
import $api from '../config/api'

export const getPricing = async () => {
  try {
    const response = await $api.get('/payment/pricing')
    return response.data
  } catch (error) {
    throw error
  }
}

export const createPaymentSession = async (reqData: { price_id: string }) => {
  try {
    const response = await $api.post('/payment/create-session', reqData)
    return response.data
  } catch (error) {
    throw error
  }
}

export const cancelPaymentPlan = async () => {
  try {
    const response = await $api.post('/payment/cancel-plan')
    return response.data
  } catch (error) {
    throw error
  }
}
